import React, { useState, useEffect } from "react";
import axios from "../../api/axiosAuth"; // axios con token
import { useAuth } from "../../context/AuthContext";

const BoletinPadre = () => {
  const { token } = useAuth();
  const [hijos, setHijos] = useState([]);
  const [selectedHijo, setSelectedHijo] = useState(null);
  const [periodos, setPeriodos] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHijos = async () => {
      try {
        const res = await axios.get("/boletin/padre/hijos", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setHijos(res.data);
        if (res.data.length) setSelectedHijo(res.data[0].estudiante_id);
      } catch (err) {
        setError(err.response?.data?.message || "Error cargando hijos");
      }
    };

    const fetchPeriodos = async () => {
      try {
        const res = await axios.get("/boletin/periodos/activos", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPeriodos(res.data);
        if (res.data.length) setSelectedPeriodo(res.data[0].id);
      } catch (err) {
        setError(err.response?.data?.message || "Error cargando periodos");
      }
    };

    fetchHijos();
    fetchPeriodos();
  }, [token]);

  const descargarBoletin = async () => {
    if (!selectedHijo || !selectedPeriodo) {
      setError("Debe seleccionar hijo y período");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.get(`/boletin/padre/${selectedHijo}/${selectedPeriodo}`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Boletin_${selectedHijo}_P${selectedPeriodo}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.response?.data?.message || "Error descargando boletín");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel">
      <h2>📄 Boletín de mis hijos</h2>

      {error && <div className="error-box">{error}</div>}

      <div className="controls">
        <label>
          Hijo:
          <select
            value={selectedHijo || ""}
            onChange={(e) => setSelectedHijo(e.target.value)}
          >
            {hijos.map((h) => (
              <option key={h.estudiante_id} value={h.estudiante_id}>
                {h.nombres_estudiante} {h.apellidos_estudiante}
              </option>
            ))}
          </select>
        </label>

        <label>
          Período:
          <select
            value={selectedPeriodo || ""}
            onChange={(e) => setSelectedPeriodo(e.target.value)}
          >
            {periodos.map((p) => (
              <option key={p.id} value={p.id}>
                {p.nombre}
              </option>
            ))}
          </select>
        </label>

        <button onClick={descargarBoletin} disabled={loading}>
          {loading ? "Descargando..." : "Descargar Boletín"}
        </button>
      </div>
    </div>
  );
};

export default BoletinPadre;
